import { render } from "./TeacherPostsView.vue?vue&type=template&id=7b527374&scoped=true"
import script from "./TeacherPostsView.vue?vue&type=script&lang=js"
export * from "./TeacherPostsView.vue?vue&type=script&lang=js"

import "./TeacherPostsView.vue?vue&type=style&index=0&id=7b527374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b527374"]])

export default __exports__